import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CcsSkeletonComponent } from '@shared/components/ccs-skeleton/ccs-skeleton.component';

@Component({
  selector: 'app-ccs-help-skeleton',
  imports: [CcsSkeletonComponent],
  template: `
    <section class="flex flex-col gap-2">
      <app-ccs-skeleton class="flex-1" height="3rem" />
      <app-ccs-skeleton class="flex-1" height="3rem" />
      <app-ccs-skeleton class="flex-1" height="3rem" />
      <app-ccs-skeleton class="flex-1" height="3rem" />
      <app-ccs-skeleton class="flex-1" height="3rem" />
      <app-ccs-skeleton class="flex-1" height="3rem" />
      <app-ccs-skeleton class="flex-1" height="3rem" />
    </section>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsHelpSkeletonComponent {}
